import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import './LeagueList.css'

const LeagueList = (props) => {

    const { idLeague, strLeague, strSport } = props.leagueInfo;

    // just for getting the logo purpose...
    const [leagues, setLeagues] = useState([]);
    let singleLogo ;
    useEffect(() => {
        const url = `https://www.thesportsdb.com/api/v1/json/1/lookupleague.php?id=${idLeague}`
        fetch(url)
            .then(res => res.json())
            .then(data => setLeagues(data.leagues[0]))
            .catch(error => console.log(error));
    }, [idLeague])

    const getLogo = () => {
        if (leagues.idLeague === idLeague) {
            return singleLogo = leagues.strBadge;
        }
    }; getLogo();


    const history = useHistory();
    const handleClick = (id) => {
        const url = `/leagueInfo/${id}`;
        history.push(url);
    }

    return (
        <div className="col-lg-4 col-md-6">
            <div className="team-card mb-4">
                <div className="team-card-logo">
                    <img src={singleLogo} alt="Logo" />
                </div>
                <h2 className="team-card-title mt-3">{strLeague}</h2>
                <p className="team-card-subtitle mb-3">Sports type: {strSport}l</p>
                <button className="btn btn-primary card-btn" onClick={() => handleClick(idLeague)}>
                    Explore <FontAwesomeIcon icon={faArrowRight} />
                </button>
            </div>
        </div>
    );
};

export default LeagueList;